import {
  userGetOptions,
  userQueryOptions,
} from '@quoruum/frontend-common/oas/gen/admin/@tanstack/react-query.gen';
import { sessionSchema } from './session';
import { defineEntitySchema, defineRelatedList } from './base/EntitySchema';

export const userSchema = defineEntitySchema({
  name: 'user',
  label: 'User',
  idField: 'id',
  primaryText: ({ first, last }) => [first, last].filter(Boolean).join(' '),
  secondaryText: 'name',
  endpoints: {
    query: userQueryOptions,
    read: userGetOptions,
  },
  relatedLists: [
    defineRelatedList({
      label: 'Sessions',
      entity: sessionSchema,
      setParentId: (id) => ({ query: { userId: id } }),
      fields: [
        { key: 'type', label: 'Type' },
        { key: 'label', label: 'Label' },
        { key: 'organizationId', label: 'Organization' },
        { key: 'expiration', label: 'Expires', type: 'datetime' },
        { key: 'auditBean.created', label: 'Created', type: 'datetime' },
      ],
    }),
  ],
  fields: [
    { key: 'id', label: 'ID', type: 'string', readOnly: true },
    { key: 'name', label: 'Name', type: 'string', readOnly: true },
    { key: 'first', label: 'First Name', type: 'string', readOnly: true },
    { key: 'last', label: 'Last Name', type: 'string', readOnly: true },
    { key: 'inactive', label: 'Inactive', type: 'boolean', readOnly: true },
    { key: 'auditBean.created', label: 'Created', type: 'datetime', readOnly: true },
    { key: 'auditBean.timestamp', label: 'Last Modified', type: 'datetime', readOnly: true },
  ],
});
